import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../utils/app-settings';
import { Observable } from 'rxjs';

@Injectable()
export class EditProfileService {

  constructor(private http: HttpClient) { }

  isEmailTaken(email: string): Observable<Boolean> {
    return this.http.get<Boolean>(AppSettings.apiUrl + "users/validateemail/" + email + "/")
  }

  isMobileNumberTaken(mobile_number: string): Observable<Boolean> {
    return this.http.get<Boolean>(AppSettings.apiUrl + "users/validatemobile/" + mobile_number)
  }
}
